
<template>
    <section class="">
      <div class="container">   
          <div class="article-nav">
              <hr class="header-underline" />

                  <div class="navs">
                    <div
                      v-for="(strategy, index) in strategies.strats"
                      :key="`strategies_navs_${index}`"
                    >
                            
                    <div  v-if="index !== strategies.selected"
                        @click="() => selectStrategy(index)"
                          class="imgIcon"
                          :style="{
                            backgroundImage:
                              'url(' +
                              require('@/assets/images/Belfast/HorizontalTabIcons/' +strategy.imageIcon ) +
                              ')',
                          }"
                        >
                          
                        </div>
                        <div v-if="index === strategies.selected"
                        
                          class="imgIcon"
                          :style="{
                            backgroundImage:
                              'url(' +
                              require('@/assets/images/Belfast/HorizontalTabIcons/' +strategy.imageIcon ) +
                              ')',
                          }"
                        >
                          
                        </div>
                      <h2
                        v-if="index !== strategies.selected"
                        @click="() => selectStrategy(index)"
                      >
                        {{ strategy.shortHeader }}
                      </h2>
                      <h2 v-if="index === strategies.selected" class="active">
                        {{ strategy.shortHeader }}
                      </h2>
                    </div>
                  </div>
                  <div class="selects">
                    <form>
                      <select v-model="strategies.selected">
                        <option
                          v-for="(strategy, index) in strategies.strats"
                          :key="`strategies_option_${index}`"
                          :value="index"
                        >
                          {{ strategy.header }}
                        </option>
                      </select>
                    </form>
                  </div>

              <hr style="margin-bottom: 4rem" />

               <div class="nav-content">
            <div class="row">
              <div class="col-md-12 col-sm-12 col-lg-6">
                <div class="nav-text">
                
                  <h5>{{ strategies.strats[strategies.selected].header }}</h5>
                  <br/>
                    <p
                      v-for="(text, index) in strategies.strats[
                        strategies.selected
                      ].text"
                      :key="`strategies_text_${index}`"
                      v-html="text"
                    >
                    </p>
                  
                  <div>
                    <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].additionalText"
                      :key="`strategies_additionaltext_${index}`"
                    >
                      {{ p }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 col-lg-6">
                <div
                
                  class="char"
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/images/Belfast/Charecteristics/' +
                        strategies.strats[
                        strategies.selected
                      ].imageRight ) +
                      ')',
                  }"
                >
                  
                </div>
              </div>
            </div>

          
          </div>
          </div>
      </div>
    </section>
</template>

<script>
export default {
  name: "HTabNew",
   components: {
    
  },
  data() {
    return {
        
       strategies: {
        selected: 0,
        strats: [
          {
            imageRight:"service.jpg",
            imageIcon:"Service.png",
            shortHeader: "Service",
            header: "Service Plans",
            text: [
              "<p>Key features of the service operations will include:</p> <ul><li>Service to operate between approximately 05:30 and 23:30 on weekdays, 07:00 to 23:30 on Saturdays and 07:00 to 22:00 on Sundays. </li><li>Peak services operating at intervals of 7-8 minutes. </li><li>Halts to be provided at a target spacing of 400m. </li><li>Existing public transport services to be integrated and provide either feeder or residual services. </li><li> Enforcement strategy to ensure no obstruction to the running ways (bus lanes). </li><li>Punctuality and reliability to be monitored with targets of 99% and 95% respectively.</li></ul>" 
            ]
          },
          {
            imageRight:"Vehicles.jpg",
            imageIcon:"Vehicles.png",
            shortHeader: "Vehicles",
            header: "Glider Vehicles",
            text: [
              "<p>The existing Glider vehicles have delivered a step change in the quality of public transport for Belfast. They provide a high-quality environment for passengers, improve accessibility for all, offer comfort, space and security accompanied with modern on-board travel information. BRT2 vehicles will adopt this same level of quality and provide:</p>",
              "<ul><li>On-board areas for wheelchairs and pushchairs/ buggies. </li><li> Multiple double-width doors for boarding and alighting. </li><li> High levels of passenger comfort with low-density seating and good legroom. </li><li> Engines to utilise the latest technologies and be low noise, low vibration and low or zero emission. </li><li> Multiple ‘infotainment’ screens with realtime information, visual and audible next halt and destination announcements. </li><li> On-board CCTV to be provided for passenger safety and security. </li><li>High standards of maintenance and cleanliness. </li><li> USB charging and wi-fi.</li></ul>", 
            ]
          },
          {
            imageRight:"ITS.jpg",
            imageIcon:"Fares-Collections.png",
            shortHeader: "Transport",
            header: "Intelligent Transport Systems(ITS) and Real-Time Information",
            text: [
              "<p>BRT2 will build upon the success of BRT Phase 1 in East and West Belfast and the opportunities brought by new and emerging technologies.</p>",
              "<p>Recommended features for the BRT2 ITS include:</p>",
              "<ul><li>All BRT2 vehicles to be fitted with an Automatic Vehicle Location (AVL) system used for real-time passenger information, operation of BRT2 priority at signal-controlled junctions and fleet operation and management. </li><li>Real-Time Passenger Information (RTPI) to be provided on-board, at all halts, and through internet and mobile phone services. </li><li> Display signs supported by audio announcements to assist visually impaired users.</li></ul>" 
            ]
            
          },
          {
            imageRight:"RunningWays.jpg",
            imageIcon:"Runningways.png",
            shortHeader: "Ways",
            header: "Running ways",
            text: [
                  "<p>The running ways consist primarily of dedicated bus lanes, priority at major junctions and elements of mixed traffic roads where enhanced priority is not feasible or practical. Experience from BRT Phase 1 has established the philosophy that BRT measures will lead to reduced road capacity for general traffic.</p><p> The introduction of Glider in East and West Belfast has demonstrated that increased delays to general traffic are, in effect, accepted as part of the “trade-off” of providing an enhanced public transport system. Retaining this approach will be fundamental to the successful operation of BRT2 services to ensure that it delivers rapid and reliable journeys. </p><p>Cyclists and motorcyclists are permitted to travel in the bus lanes, which has the potential to improve journey times for these road users.</p>"
            ]
          },
          {
            imageRight:"Fares.jpg",
            imageIcon:"IntelligentTS.png",
            shortHeader: "Fares",
            header: "Fares and Fare Collection",
            text: [
                  "<p>Consistent with the Glider operations in East and West Belfast, tickets for BRT2 will be purchased prior to boarding, so as to minimise waiting times at halts.</p>",
                  "<p>Key features include:</p>",
                  "<ul><li>Fares and ticketing consistent with those on local bus services to enable easy interchange. </li><li> Concessionary fares in line with those associated with existing Glider services. </li><li> Off-board ticketing facilities to minimise halt waiting times supported by on-vehicle ticket inspection. </li><li> Payment systems and tariffs to encourage cashless payment.</li></ul>" 
            ]
          },
          {
            imageRight:"Halts.jpg",
            imageIcon:"Halts-Interchanges.png",
            shortHeader: "Halts",
            header: "Halts and Interchanges",
            text: [
                  "<p>In East and West Belfast, the Glider halts have been a key part of the system image offering a distinct and high quality passenger waiting environment. Building on this success, the recommended requirements for the BRT2 halts and interchanges are:</p>",
                  "<ul><li> High quality branded halts with paving, illuminated shelters, seating, off-board ticketing machines and validators, realtime passenger information & CCTV. </li><li>Safe and secure pedestrian routes to be provided to/from halts with pedestrian crossings providing access to halts. </li><li> Bus access kerbs provided at each halt to allow boarding at each door. </li><li> Halt design to be consistent and minimise step height onto vehicles. </li><li> Interchange halts to be provided in the City Centre and at locations of interchange with other public transport services. </li><li> Interchange and/or Park & Ride facilities to be located at key locations with high quality and secure parking facilities for vehicles and cycles where appropriate.</li></ul>"  
            ]
          },
          
        ],
      },
    }
  },
    methods: {
    selectStrategy(index) {
      this.strategies.selected = index;
    }
  },
 
  mounted() {
   
  },
  watch: {
    $route(to, from) {
      this.activeInstance = to.params.root;
    },
  },
};
</script>
<style lang="scss" scoped>
.img{
    height: 66vh!important;
}
.imgIcon{
  width: 80px;
    height: 88px;
    border-radius: 20px;
    margin-bottom: 1rem;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
}
</style>